import styled from "@emotion/styled"
import { keyframes } from '@emotion/react'

export const Wrap = styled.div`
  position: relative;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--color-grayscale-37);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16), 0px 16px 16px 0px rgba(0, 0, 0, 0.08);
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 8px;
  outline-color: var(--color-white);

  & > img {
    border-radius: 16px;
    max-width: 100%;
    height: auto;
  }
`

const showIcon = keyframes`
  from {
    transform: scale(0.5);
  }
  to {
    transform: scale(1);
  }
`

export const Icon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 24px;
  color: var(--color-white);
  background: var(--color-grayscale-800);
  box-shadow: var(--elevation-light-high);
  outline-style: solid;
  outline-width: 1.6px;
  outline-offset: -5px;
  outline-color: var(--color-grayscale-500);

  & > svg {
    width: 46px;
    height: 46px;
    animation: ${showIcon} .2s cubic-bezier(.33,1,.68,1);
  }
`
